import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import RidGenerator from 'utils/swarm/rid-generator';
import { ResultGamesRequestParams } from 'interfaces/results';
import { WebsocketEnhanced } from 'interfaces/spring-websocket-interfaces';
import { executeCommand } from 'services/get-data-level';
import { connectingWS } from 'hooks/useSpringConnect';

export const getActiveCompetitions = (
  fromDate: number,
  toDate: number,
  callback: Function,
  callbackError?: Function,
  sportType?: string | null
): void => {
  const command = {
    command: CommandNames.GET_ACTIVE_COMPETITIONS,
    params: {
      from_date: fromDate,
      to_date: toDate,
      sport_type: sportType ? sportType : null
    },
    rid: RidGenerator.gForCommand()
  };

  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(command, '', callback, null, callbackError);
  });
};

export const getResultGames = (
  params: ResultGamesRequestParams,
  callback: Function
): void => {
  const command = {
    command: CommandNames.GET_RESULT_GAMES,
    params: params,
    rid: RidGenerator.gForCommand()
  };

  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(command, '', callback);
  });
};

export const getGameResults = (gameId: string, callback: Function): void => {
  const command = {
    command: CommandNames.GET_RESULTS,
    params: {
      game_id: gameId
    },
    rid: RidGenerator.gForCommand()
  };

  connectingWS.then((socket: WebsocketEnhanced) => {
    socket.sendCommand(command, '', callback);
  });
};

export const findGames = (
  params: { what: any; where: any },
  callback: Function
): void => {
  executeCommand(
    RidGenerator.gForCommand(),
    params.what,
    params.where,
    callback
  );
};
